import { useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useCheckProfessionalData() {
  const check = useCallback((appointment) => {
    return quarkusApi.post('/appointments/check-professional-data', appointment, {
      headers: { Authorization: sessionStorage.getItem('token') },
    });
  }, []);

  return { check };
}
